module.exports = __webpack_public_path__ + "img/begin_txt.16249be3.png";